import {drawerWidth} from "../config";

export const layoutStyles = {
    layout: {
        outerBoxContainer: {
            display: "flex",
        },
        innerBoxContainer: {
            flexGrow: 1,
            position: "relative",
        },
        drawer: {
            width: drawerWidth,
            zIndex: 1203,
        },
        drawerPaper: {
            width: drawerWidth,
            borderRight: "none",
        },
        suspenseBoundaryBoxContainer: {
            my: 2,
        },
    },
    nav: {
        toolbarIconButton: {
            mr: 1,
        },
        toolbarBox: {
            ml: "auto",
        },
    },
    navUser: {
        popoverOuterBox: {
            display: "flex",
        },
        popoverInnerBox: {
            pt: 2,
            pl: 2,
        },
    }
}
